<template>
<iframe-template
  :src='src'
  :loading='req.loading'
  :width='previewSize'
  :visible='ready' >

  <template slot='about' >
    <v-alert type='info' tile text border='left' >
      Your appointment page will be linked in your notifications.<br/>
      Your clients can use it to find the latest information regarding your appointment.
    </v-alert>

    <v-alert v-if='isDemo && isDemo === true' type='warning' tile text dismissible border='left' >
      Note: we couldn't find any appointments linked to your account using the search criteria.
      We are showing an example from our demo account to give you a sense of what this page looks like
    </v-alert>
  </template>

  <template slot="iframe-toolbar" >
    <v-btn-toggle tile group mandatory
      color="deep-purple accent-3"
      v-model="mobile" >

      <v-btn icon color='accent' :value='false' >
        <v-icon>mdi-desktop-mac</v-icon>
      </v-btn>
      <v-btn icon :value='true' >
        <v-icon>mdi-cellphone</v-icon>
      </v-btn>

    </v-btn-toggle>
  </template>

  <template slot="preferences" >
    <v-card-title class='subtitle-1 overline' >
      Preview Preferences
    </v-card-title>
    <v-card-text>
      <!-- <v-checkbox v-model='mobile' dense class='my-0 py-0' label='Mobile view' /> -->
      <v-checkbox v-model='future' @change='dirty=true' dense class='my-0 py-0' label='Appointment in the future' />

      <v-checkbox dense
        v-model='past'
        @change='dirty=true'
        class='my-0 py-0'
        label='Appointment in the past' />

      <v-checkbox dense
        v-model='is_online'
        class='my-0 py-0'
        label='Online appointment type'
        @change='dirty=true'  />

      <!-- <v-checkbox dense
        v-model='is_flexible'
        @change='dirty=true'
        class='my-0 py-0'
        label='Flexible location appointment type' /> -->

    </v-card-text>
    <v-card-actions>
      <v-btn tile block
        @click='get'
        :disabled='!dirty'
        color='primary'>Update View</v-btn>
    </v-card-actions>
  </template>
</iframe-template>
</template>
<script>
import IframeTemplate from '@/views/brand/digitalassets/IframeTemplate.vue'
import {DEFAULT_MOBILE_PHONE_WIDTH} from '@/store/constants.js'

export default {
  name: 'AppointmentPreview',
  components: {IframeTemplate},
  data () {
    return {
      mobile: true,
      past: false,
      future: true,
      is_online: false,
      req: {
        resource: 'ag.appointments',
        extra: 'random'
      },
      dirty: false
    }
  },
  mounted () {
    this.get()
  },
  computed: {
    src () {

      let u = this.getObjectPath(this.req, 'result.url')
      // if (u) {
      //   u = u.replace('https://appt.guru', 'http://appointmentguru.docker.localhost')
      // }
      return u
    },
    isDemo () {
      return this.getObjectPath(this.req, 'result.demo', false)
    },
    ready () {
      return (this.req.status === 200)
    },
    previewSize () {
      if (this.mobile) { return DEFAULT_MOBILE_PHONE_WIDTH }
      else { return '100%' }
    },
    params () {
      let data = {}
      if (this.past) { data['past'] = 't' }
      if (this.future) { data['future'] = 't' }
      if (this.is_online) { data['is_online'] = 't' }
      return data
    }
  },
  watch: {
    past () {
      if (this.past === true) { this.future = false }
    },
    future () {
      if (this.future === true) { this.past = false }
    }
  },
  methods: {
    get () {
      this.req.params = this.params
      this.$request('get', this.req)
    }
  }
}
</script>
